'use strict';

// Предоставляет директивы для работы с датой и временем.

(function () {
	angular.module('dateTime', []);
})();